module.exports = __webpack_public_path__ + "static/media/Westwell_Wines_250x_2x WHITE.47c82060.avif";